export interface ApiKeyModel {
  id: number;
  name: string;
  keyPrefix: string;
  plaintextKey?: string;
  active: boolean;
  createdDate: string;
  lastUsedTimestamp?: string;
}
